import React, { useEffect } from 'react';
import HeaderMain from '../../components/Header/HeaderMain';
import PopupCardContent from '../Popup/PopupCardContent';
import FooterMain from '../../components/Footer/FooterMain';
import FreeVoucherPopup from '../FreeVoucherPopup/FreeVoucherPopup';
import useUiStateStore from '../../_store/useUiStateStore';

const LayoutHome = (props) => {
    const { moveToPackage, moveToProduct, moveToContact, children, selectedCardItem } = props;
    const { isRegistPopupOpen, isCheckupCardPopupOpen } = useUiStateStore();

    return (
        <div>
            <HeaderMain 
                moveToPackage={moveToPackage}
                moveToProduct={moveToProduct}
                moveToContact={moveToContact}
            />
            <div className="contents">
                { children }
            </div>
            <PopupCardContent selectedCardItem={selectedCardItem}/>
            <FreeVoucherPopup />
            <FooterMain />
            <div className={`modal-dim ${isRegistPopupOpen || isCheckupCardPopupOpen ? 'show' : ''}`}></div>
        </div>   
    )    
}

export default LayoutHome;
